import Button from '../Base/Button/Button';
import PropTypes from 'prop-types';
import { useState } from 'react';
import styles from './TestForm.module.scss';
import TextField from '../Base/TextField/TextField';

export default function TestForm(props) {
	const [name, setName] = useState('');

	const handleSubmit = () => {
		console.log({ name });

		props.onSubmit &&
			props.onSubmit({
				name,
			});
	};

	return (
		<form className={styles.testForm}>
			<TextField onChange={setName} placeholder={'name'} />

			<Button text={'submit'} onClick={handleSubmit} />
		</form>
	);
}

TestForm.propTypes = {
	onSubmit: PropTypes.function,
};
